import styled from 'styled-components';
import { pxToRem } from '../utils/ConvertUtils';
import i18n from '../i18n/i18n';

interface BTOutlineButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  color?: string;
  borderColor?: string;
  borderWidth?: string | number; // ✅ 테두리 두께 추가
  centered?: boolean;
  backgroundColor?: string;
  width?: string | number;
  height?: string | number;
  fontSize?: string | number;

  // 호버 관련 prop
  hoverBackgroundColor?: string;
  hoverTextDecoration?: string;
  hoverBorderColor?: string;
  hoverColor?: string;

  // Google Analytics 추적을 위한 속성
  'data-analytics-name'?: string;
}

const StyledButton = styled.button<BTOutlineButtonProps>`
  width: ${({ width }) => (width ? (typeof width === 'number' ? `${width}px` : width) : '100%')};
  height: ${({ height }) => (height ? (typeof height === 'number' ? `${height}px` : height) : '102px')};
  border: ${({ borderWidth, borderColor }) =>
    `${borderWidth ? (typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth) : '3px'} solid ${borderColor || 'white'}`};
  border-radius: 10px;
  background-color: ${({ backgroundColor }) => backgroundColor || 'transparent'};
  color: ${({ color }) => color || 'white'};
  font-family: ${({ theme }) => {
    const isChina = i18n.language === 'zh';
    return isChina 
      ? `${theme.typography.fontFamily}, LINE Seed Sans KR`
      : `LINE Seed Sans KR, ${theme.typography.fontFamily}`;
  }};
  font-weight: 700;
  font-size: ${({ fontSize }) => (fontSize ? (typeof fontSize === 'number' ? `${fontSize}px` : fontSize) : pxToRem(28))};
  letter-spacing: 0px;

  display: flex;
  align-items: center;
  justify-content: ${({ centered }) => (centered ? 'center' : 'flex-start')};
  padding: ${({ centered }) => (centered ? '0' : '0 0 0 40px')};
  cursor: pointer;

  &:hover {
    background-color: ${({ hoverBackgroundColor }) => hoverBackgroundColor || 'transparent'};
    text-decoration: ${({ hoverTextDecoration }) => hoverTextDecoration || 'underline'};
    border-color: ${({ hoverBorderColor, borderColor }) => hoverBorderColor || borderColor || '#fff'};
    color: ${({ hoverColor, color }) => hoverColor || color || 'white'};
  }

  &:focus {
    outline: none;
  }
`;

export const BTOutlineButton = ({
  onClick,
  children,
  color,
  borderColor,
  borderWidth, // ✅ 전달
  centered,
  backgroundColor,
  width,
  height,
  fontSize,
  hoverBackgroundColor,
  hoverTextDecoration,
  hoverBorderColor,
  hoverColor,
  'data-analytics-name': dataAnalyticsName,
}: BTOutlineButtonProps) => {
  return (
    <StyledButton
      onClick={onClick}
      color={color}
      borderColor={borderColor}
      borderWidth={borderWidth} // ✅ 전달
      centered={centered}
      backgroundColor={backgroundColor}
      width={width}
      height={height}
      fontSize={fontSize}
      hoverBackgroundColor={hoverBackgroundColor}
      hoverTextDecoration={hoverTextDecoration}
      hoverBorderColor={hoverBorderColor}
      hoverColor={hoverColor}
      data-analytics-name={dataAnalyticsName}
    >
      {children}
    </StyledButton>
  );
};
